import TextField from "@material-ui/core/TextField";
import React from "react";
import {CHANGE_ORDER_DESCRIPTION} from "../../../actions/actionsTypes";
import {connect} from "react-redux";
import i18n from "../../../i18nextInitiator";

/**
 * Translation funciton.
 */
const t = i18n.getFixedT('fa','general');

/**
 * maps dispatch functions to component props.
 * @param dispatch
 */
const mapDispatchToProps = dispatch => ({
    changeDescription: e => {dispatch({type: CHANGE_ORDER_DESCRIPTION, value: e.target.value})},
});

/**
 * map redux state
 * @param state
 */
const mapStateToProps = state => ({ ...state });
/**
 * description input component which is used in pre invoice page
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const DescriptionInput = props => {

    const [descRows, setDescRows] = React.useState(1);

    return <TextField variant={"filled"}
                                  onChange={props.changeDescription}
                                  rows={descRows}
                                  InputProps={{
                                      onFocus:()=>setDescRows(3),
                                      onBlur:()=>setDescRows(1)
                                  }}
                                  label={t("invoice.pre.order-description")}
                                  multiline
                                  fullWidth/>
}

export default connect(mapStateToProps, mapDispatchToProps)(DescriptionInput)